<template>
  <draggable :list="list" :draggable="draggable">
    <transition-group>
      <slot />
    </transition-group>
  </draggable>
</template>
<script>
import draggable from 'vuedraggable'

export default {
  name: 'Draggable',
  components: {
    draggable,
  },
  props: {
    items: {
      type: Array,
    },
    draggable: String,
  },
  computed: {
    list: {
      get() {
        return this.items
      },
      set(value) {
        this.$emit('input', value)
      },
    },
  },
}
</script>
